import { getFilterLeaves } from 'modules/decision/pages/Explore/helpers/filterTree';

export const sortByDisplayIndex = (
    a: SentenceDimensionT | SentenceFilterT,
    b: SentenceDimensionT | SentenceFilterT,
) => {
    if (!a.displayIndex) return -1;
    if (!b.displayIndex) return 1;
    return a.displayIndex > b.displayIndex ? 1 : -1;
};

export const getDisplayIndex = (state: SentenceQueryT) =>
    state.metrics.length +
    state.dimensions.length +
    getFilterLeaves(state.filters).length;
